const steps = [
  {
    number: "01",
    icon: "ri-discuss-line",
    title: "Consultation & Site Survey",
    desc: "Our engineers visit your site, take precise measurements, understand your workflow, and advise on the optimal kitchen layout and equipment selection.",
    duration: "Day 1–2",
  },
  {
    number: "02",
    icon: "ri-draft-line",
    title: "3D Design & Approval",
    desc: "We produce detailed 3D and 2D drawings showing your exact kitchen configuration. You review, suggest changes, and sign off before any steel is cut.",
    duration: "Day 3–5",
  },
  {
    number: "03",
    icon: "ri-tools-line",
    title: "In-House Fabrication",
    desc: "Our skilled welders and fabricators produce every unit in our Nairobi workshop using food-grade stainless steel with strict quality checks at each stage.",
    duration: "Day 6–20",
  },
  {
    number: "04",
    icon: "ri-truck-line",
    title: "Delivery & Installation",
    desc: "Our installation team delivers, assembles, and commissions your kitchen on-site — connecting utilities, testing every component, and handing over a fully operational kitchen.",
    duration: "Day 21–25",
  },
];

export default function KitchenProcess() {
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">Our Methodology</span>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight">
            How We Work
          </h2>
          <p className="text-gray-500 text-sm mt-4 max-w-lg mx-auto leading-relaxed">
            A proven 4-step process that takes you from idea to a fully operational commercial kitchen — on time, on budget, no surprises.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-16 left-[calc(12.5%+20px)] right-[calc(12.5%+20px)] h-px bg-teal-100 z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center group">
                {/* Icon circle */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-white border-2 border-teal-200 rounded-full group-hover:bg-teal-600 group-hover:border-teal-600 transition-all duration-300">
                    <i className={`${step.icon} text-2xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <span className="absolute -top-2 -right-2 bg-teal-600 text-white text-xs font-extrabold w-6 h-6 flex items-center justify-center rounded-full leading-none">
                    {i + 1}
                  </span>
                </div>

                {/* Duration badge */}
                <span className="bg-teal-50 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wider">
                  {step.duration}
                </span>

                <h3 className="text-gray-900 font-bold text-sm uppercase tracking-wide mb-3">{step.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Timeline image strip */}
        <div className="mt-16 rounded-lg overflow-hidden relative h-56">
          <img
            src="/images/kitchen/custom-design.webp"
            alt="Our fabrication process"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-teal-900/80 via-teal-900/40 to-transparent flex items-center px-12">
            <div>
              <p className="text-teal-200 text-xs uppercase tracking-widest mb-2">Our Promise</p>
              <p className="text-white text-2xl md:text-3xl font-extrabold max-w-md leading-tight">
                Kitchen ready in as little as <span className="text-teal-400">25 working days</span>
              </p>
              <a
                href="#inquiry"
                onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
                className="mt-5 inline-block bg-teal-600 hover:bg-teal-500 text-white font-bold px-6 py-2.5 rounded-md uppercase text-xs tracking-wider transition-colors cursor-pointer whitespace-nowrap"
              >
                Start Your Project
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
